import {
  KAActionBucketPageDataLabelValues,
  getKaLabelTagColor,
} from '../collections/KAActionBucketPageDataLabels';
import { getAgentCollectionLabels } from './agentCollectionHelpers';

/** API wire value is `award`. Older UI drafts used `awardsEntrant`. */
export function normalizePersonalizationToolType(type) {
  if (type === 'awardsEntrant') return 'award';
  return type;
}

export const KA_REQUIRED_FIELDS_OPTIONS_BY_TYPE = Object.freeze({
  registrant: [
    { label: 'Top sessions', value: 'top_sessions' },
    { label: 'Top exhibitors', value: 'top_exhibitors' },
    { label: 'Top passes', value: 'top_passes' },
    { label: 'Top experiences', value: 'top_experiences' },
    { label: 'Top speakers', value: 'top_speakers' },
    { label: 'Event fitment', value: 'event_fitment' },
  ],
  sponsor: [
    { label: 'Sponsorship packages', value: 'sponsorship_packages' },
    { label: 'Matched audience', value: 'matched_audience' },
    { label: 'Event fitment', value: 'event_fitment' },
  ],
  award: [
    { label: 'Award recommendations', value: 'award_recommendations' },
    { label: 'Award judges', value: 'award_judges' },
    { label: 'Award key events', value: 'award_keyevents' },
    { label: 'Event fitment', value: 'event_fitment' },
  ],
});

export const KA_REQUIRED_FIELD_TO_LABELS = Object.freeze({
  top_sessions: [KAActionBucketPageDataLabelValues.PersonalizationTool_Registrant_Sessions],
  top_exhibitors: [KAActionBucketPageDataLabelValues.PersonalizationTool_Registrant_Exhibitors],
  top_passes: [KAActionBucketPageDataLabelValues.PersonalizationTool_Registrant_Passes],
  top_experiences: [KAActionBucketPageDataLabelValues.PersonalizationTool_Registrant_Experiences],
  top_speakers: [KAActionBucketPageDataLabelValues.PersonalizationTool_Registrant_Speakers],
  sponsorship_packages: [
    KAActionBucketPageDataLabelValues.PersonalizationTool_Sponsors_SponsorshipPackages,
  ],
  matched_audience: [
    KAActionBucketPageDataLabelValues.PersonalizationTool_Sponsors_MatchedAudiences,
  ],
  award_recommendations: [
    KAActionBucketPageDataLabelValues.PersonalizationTool_Awards_AwardEntrants,
  ],
  award_judges: [KAActionBucketPageDataLabelValues.PersonalizationTool_Awards_AwardJudges],
  award_keyevents: [
    KAActionBucketPageDataLabelValues.PersonalizationTool_Awards_AwardKeyEvents,
    KAActionBucketPageDataLabelValues.PersonalizationTool_Awards_AwardKeyDates,
  ],
  event_overview: [KAActionBucketPageDataLabelValues.PersonalizationTool_Events_EventInfo],
  event_fitment: [KAActionBucketPageDataLabelValues.PersonalizationTool_Events_EventInfo],
});

const PERSONALIZATION_TYPE_ALIASES = Object.freeze({
  registrants: 'registrant',
  sponsors: 'sponsor',
  awardsEntrant: 'award',
});

export function getKaRequiredFieldLabel(personalizationType, fieldValue) {
  const normalizedType =
    PERSONALIZATION_TYPE_ALIASES[personalizationType] ||
    normalizePersonalizationToolType(personalizationType);
  const typedOptions = KA_REQUIRED_FIELDS_OPTIONS_BY_TYPE?.[normalizedType] ?? [];
  const typedMatch = typedOptions.find(opt => opt.value === fieldValue);
  if (typedMatch) return typedMatch.label;

  for (const options of Object.values(KA_REQUIRED_FIELDS_OPTIONS_BY_TYPE)) {
    const match = options.find(opt => opt.value === fieldValue);
    if (match) return match.label;
  }

  return fieldValue;
}

export function getKaRequiredFieldTagColor(fieldValue) {
  const kaLabel = KA_REQUIRED_FIELD_TO_LABELS[fieldValue]?.[0];
  return kaLabel ? getKaLabelTagColor(kaLabel) : 'default';
}

/** Required fields that no longer have a matching label in the given collections. */
export function getOrphanedRequiredFields(collections, selectedFields = []) {
  const labels = new Set(
    (collections ?? []).flatMap(c => getAgentCollectionLabels(c)).filter(Boolean)
  );

  return selectedFields.filter(field => {
    const needed = KA_REQUIRED_FIELD_TO_LABELS[field];
    return needed?.length > 0 && !needed.some(label => labels.has(label));
  });
}
